import { FETCH_PERMISSIONS, FETCH_PERMISSIONS_ATTEMPT } from '../types'
import axios from 'axios';
export const fetchpermissions = () => {

    return (dispatch) => {
        dispatch({ type: FETCH_PERMISSIONS_ATTEMPT });
        //call the backend
            axios.post('https://zliten.onwan.ly/API/users/fetchPermissions.php')
             .then((resp) => dispatch({ type: FETCH_PERMISSIONS, data: resp.data }))
            /* .then((resp) => console.log(resp.data))*/
            .catch(error => console.error(error));
    }
}
